import { Grid, Card, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import { SUBADMIN } from 'constants.js';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { handleErrors, checkPrivilege } from "common.js";
import { useMaterialUIController, setSubadminContext } from "context";
import configurationContext from "contextConfig";
import { PRIVILEGE } from "constants.js";

function ManageSubadmins() {
  const navigate = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { subadminContext } = controller;

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [subadminData, setData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const searchFilterData = { 'statusFilter': subadminContext.statusFilter, "searchBy": subadminContext.searchBy, "searchValue": subadminContext.searchValue, "orderBy": subadminContext.orderBy, "orderValue": subadminContext.orderValue };
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const [isSubadminContextChanged, setSubadminContextChanged] = useState(false);

  const deleteSubadmin = async (id) => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: BASE + "api/subadmin/remove/" + id,
      method: "POST",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    }).then(function (response) {
      setIsLoading(false)
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          if (subadminData.data.rows) {
            const subadminRows = subadminData.data.rows;
            for (const subadminKey in subadminRows) {
              if (subadminRows[subadminKey]['id'] == id) {
                setData(prevState => {
                  const updatedSubadminStatus = prevState.data.rows.map(item => {
                    if (item.id === id) {
                      return { ...item, status: 2 };
                    }
                    return item;
                  })
                  return {
                    ...prevState,
                    data: {
                      ...prevState.data,
                      rows: updatedSubadminStatus
                    }
                  };
                });
              }
            }
          }
        }
        else {
          toast.error(t(message));
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = () => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: BASE + "api/subadmin/list",
      method: "POST",
      data: { ...searchFilterData, pageSelected: pageSelected },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      }
    }).then(function (response) {
      setIsLoading(false);
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);
          if (response.data.data.totalCount)
            setResponseResultCount(response.data.data.totalCount);
        }
        else {
          toast.error(t(message));
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const handleResetFilters = () => {
    setSubadminContext(dispatch, initialState.subadminContext);
    setSubadminContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/subadmin/manage/page-1");
    else
      navigate("/subadmin/manage");
  };

  useEffect(() => {
    const hasChanged = Object.keys(subadminContext).some(
      key => subadminContext[key] !== initialState.subadminContext[key]
    );
    setSubadminContextChanged(hasChanged);
  }, [subadminContext]);

  const columns = [
    { Header: t('id'), accessor: "id", align: "left" },
    { Header: t('name'), accessor: "name", align: "left" },
    { Header: t('email'), accessor: "email", align: "left" },
    { Header: t("status"), accessor: "status", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];
  const finalObj = [];

  const generateActionLinks = (id) => {
    return (
      <>
        {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("subadmin", "read") || checkPrivilege("subadmin", "write")))) ?
          <MDTypography component="a" onClick={(event) => { event.preventDefault(); navigate("/subadmin/edit/" + id) }} mr={1}>
            <Tooltip title={t('edit')}><Box className="ActionEdit"><EditIcon /></Box></Tooltip>
          </MDTypography>
          : null
        }
        {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("subadmin", "delete"))) ?
          <>
            <span className="spanPadding5"></span>
            <MDTypography component="a" onClick={() => deleteSubadmin(id)}>
              <Tooltip title={t('delete')}><Box className="ActionBlock"><DeleteIcon /></Box></Tooltip>
            </MDTypography>
          </>
          : null}
      </>
    );
  }

  if (subadminData.data && subadminData.data.rows) {
    let subadminRecords = subadminData.data.rows;
    for (const rowKey in subadminData.data.rows) {
      let subadminRecord = subadminRecords[rowKey];
      if (subadminRecord.id > 0) {
        let tempObj = {
          id: '#' + subadminRecord.id,
          name: subadminRecord.name,
          email: subadminRecord.email,
          status: <span className={'statusD' + subadminRecord.status}>
            {(subadminRecord.status == SUBADMIN.ACTIVE) ? <span>{t('active')}</span> :
              (subadminRecord.status == SUBADMIN.INACTIVE) ? <span>{t('inactive')}</span> :
                (subadminRecord.status == SUBADMIN.DELETED) ? <span>{t('deleted')}</span> :
                  null}</span>,
          action:
            <span className="actionLinksStyle">
              {generateActionLinks(subadminRecord.id)}
            </span>
        };
        finalObj.push(tempObj);
      }
    }
  }
  const rows = finalObj;
  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("Manage Subadmin")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {(Object.keys(subadminData).length > 0) ?
        <MDBox pt={6} pb={3} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
                  <Grid container className="FilterSectionBox" spacing={2}>
                    <Grid item xs={12} sm={2} md={2} >
                      <MDInput
                        select
                        name="statusFilter"
                        label={t('status')}
                        value={searchFilterData.statusFilter}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        className="ManageProductTopSecip"
                        onChange={(obj) => {
                          setSubadminContext(dispatch, { ...subadminContext, statusFilter: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'all'}>{t('all')}</MenuItem>
                        <MenuItem value={SUBADMIN.ACTIVE}>{t('active')}</MenuItem>
                        <MenuItem value={SUBADMIN.INACTIVE}>{t('inactive')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="searchBy"
                        label={t('searchBy')}
                        value={searchFilterData.searchBy}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        onChange={(obj) => {
                          if (obj.target.value == 'none') {
                            setSubadminContext(dispatch, { ...subadminContext, searchValue: '', searchBy: obj.target.value });
                          }
                          else
                            setSubadminContext(dispatch, { ...subadminContext, searchBy: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'none'}>{t('none')}</MenuItem>
                        <MenuItem value={'id'}>{t('id')}</MenuItem>
                        <MenuItem value={'name'}>{t('name')}</MenuItem>
                        <MenuItem value={'email'}>{t('email')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} >
                      <FormControl >
                        <MDInput
                          key={'searchValue'}
                          value={searchFilterData.searchValue}
                          disabled={(searchFilterData.searchBy == 'none') ? true : false}
                          type="text" name="searchValue" label={t("searchInput")}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(obj) => {
                            setSubadminContext(dispatch, { ...subadminContext, searchValue: obj.target.value });
                          }} fullWidth />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="orderBy"
                        value={searchFilterData.orderBy}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        label={t('orderBy')}
                        onChange={(obj) => {
                          setSubadminContext(dispatch, { ...subadminContext, orderBy: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'createdAt'}>{t('createdAt')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={1} md={1}>
                      <MDInput
                        select
                        name="orderValue"
                        value={searchFilterData.orderValue}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        label={t('order')}
                        onChange={(obj) => {
                          setSubadminContext(dispatch, { ...subadminContext, orderValue: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                        <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                      <FormControl className="filterSubmit">
                        <MDButton
                          onClick={() => {
                            navigate("/subadmin/manage");
                            if (typeof pageNo === "undefined")
                              data();
                          }}
                          key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple fullWidth>{t('submit')}</MDButton>
                        {isSubadminContextChanged && (
                          <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    showTotalEntries={true}
                    responseResultCount={responseResultCount}
                    paginationSize={MyContext.paginationSize}
                    paginationLink={"/subadmin/manage/page-"}
                    pageSelected={pageSelected}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ManageSubadmins;
